
import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { RadioButton, TextInput, DropDown } from '../../../../../../components/form/form';
import { getModeOfPayments, getSettBankList } from '../../../../../../helpr/orderFormData';

/*
  Render Mode Of Payment Option
*/
const ModeOfPayment = ({orderFormState}) => {
  const { getField, getTextFieldProps, getRadioButtonProps, getDropdownProps  } = orderFormState;
  const required = (name) => <a>{name}<span style={{color: 'red'}}>*</span></a>;

  /*
    Render Fields Depending on the
    Mode of Payment chosen
  */
  const renderAdditionalFields = (option) => {
    if( option === 'RTGS'){
      return (
        <>
          <Row>
            <Col>
              <p>
                We have caused the crediting of the Total Purchase Amount (as stated above)
                in cleared funds, covering full payment for the Bonds covered by this Application
                to the Selling Agent named below, for the account of the Issuer.
              </p>
            </Col>
          </Row>
        </>
      )
    }
    if( option === 'BANK_CHECK' ){
      return (
        <>
          <Row>
            <Col>
              <p>
                Attached herewith is a check for Total Purchase Amount (as stated above) in cleared
                funds, covering full payment for the Bonds covered by this Application in favor of
                the Selling Agent named below, for the account of the Bank.
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <DropDown inputProps={getDropdownProps('modeOfPaymentBank')} values={getSettBankList()}>
                { required('Bank:') }
              </DropDown>
            </Col>
            <Col>
              <TextInput inputProps={getTextFieldProps('modeOfPaymentCheckNumber')}>
                { required('CHECK #:') }
              </TextInput>
            </Col>
          </Row>
        </>
      )
    }
    if( option === 'DIRECT_DEBIT' ){
      return (
        <>
          <Row>
            <Col>
              <p>
                <b>I/We hereby authorize the</b> debiting of my/our account with the Drawee Bank named below,
                with the corresponding account number, of Total Purchase Amount (as stated above) in cleared funds,
                covering full payment for the Bonds covered by this Application in favor of the Selling Agent named below,
                for the account of the Bank.
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInput inputProps={getTextFieldProps('modeOfPaymentDebitAccountNumber')}>
                { required('Debit Account Number:') }
              </TextInput>
           </Col>
            <Col>
              <DropDown inputProps={getDropdownProps('modeOfPaymentBank')} values={getSettBankList()}>
                { required('Bank:') }
              </DropDown>
            </Col>
          </Row>
        </>
      )
    }
  }

  return (
    <>
      <Row>
        <Col md="6">
          <RadioButton inputProps={getRadioButtonProps('modeOfPaymentOption')} data={getModeOfPayments()}>
            { required('MODE OF PAYMENT:') }
          </RadioButton>
        </Col>
      </Row>
      { renderAdditionalFields(getField('modeOfPaymentOption')) }
    </>
  )
}

export default ModeOfPayment;

